module.exports = __webpack_public_path__ + "static/media/delete-icon.43af94b7.svg";